module.exports = __webpack_public_path__ + "img/10-04_Developing people.5d5d6261.svg";